<div class="dmsans">
<section *ngIf="type=='onpage' && (!isMobile || skipMobileCheck)" class="{{customTheme}}">
  <app-payment-header *ngIf="isMobile && paymentHeader" [isReward]="checkReward()" [selectedCurrency]="contributeDetails?.selected_currency"
                      (userSelectionCurrency)="getCurrencyFromHeader($event)" [screenName]="screenName"
                      [fundraiser]="fundraiser" [showBeneficiary]="showBeneficiary" [contributeDetails]="contributeDetails"
                      [type]="headerType">
  </app-payment-header>
  <app-amount-form *ngIf="contributeDetails" [isReward]="checkReward()" [contributeDetails]="contributeDetails" [origin]="origin"
                  [campaignId]="params?.id" (userSelectionCurrency)="getCurrencyFromHeader($event)"
                  (isSumbited)="isSubmited($event)" [config]="config" [isQR]="isQR" [captchaType]="captchaType"
                  [isLoading]="isCurrencyLoading" [paymentFlowType]="type" [isRewardSelected]="isRewardSelected" [onpage]="onpage" [paymentIcons]="paymentIcons"
                  [miniStory]="payment_config.mini_story" [recommendTag]="recommendTag" [inputFields]="inputFields" [position]="position" [isSipStory]="isSipStory" [tagLabel]="tagLabel" [theme]="theme" [payment_config]="payment_config">
  </app-amount-form>
</section>

<!-- Fulll payment module -->
<section *ngIf="type=='full'">
  <ng-template [ngTemplateOutlet]="fullPayment"></ng-template>
</section>
<ng-template #fullPayment>
  <section class="full-payment-wrapper {{customTheme}}" *ngIf="contributeDetails" id="full-payment-wrapper">
    <div *ngIf="urlParams?.ct && params?.payment === 'form' && isStoryLink && fundraiser?.story_title; else defaultHeader">
      <app-payment-header-stories [isReward]="checkReward()" [selectedCurrency]="contributeDetails?.selected_currency"
                          (userSelectionCurrency)="getCurrencyFromHeader($event)" [screenName]="screenName"
                          [fundraiser]="fundraiser" [showBeneficiary]="showBeneficiary" [contributeDetails]="contributeDetails" [isStandAlone]="isStandAlone">
      </app-payment-header-stories>
    </div>
    <div *ngIf="vars.askTipOnPayOpt && params?.payment=='options'" class="tipToggle">
      <app-component-loader selector="app-tip-toggle" />
    </div>
    <ng-template #defaultHeader>
      <app-payment-header *ngIf="contributeDetails?.selected_currency" [isReward]="checkReward()" [selectedCurrency]="contributeDetails?.selected_currency"
            (userSelectionCurrency)="getCurrencyFromHeader($event)" [screenName]="screenName"
            [fundraiser]="fundraiser" [showBeneficiary]="(showBeneficiary && !isSipStory) && !urlParams?.hide_el" [contributeDetails]="contributeDetails"
            [isStandAlone]="isStandAlone" [type]="headerType" [tiptyp]="tiptyp">
      </app-payment-header>
    </ng-template>
    <app-rewards *ngIf="contributeDetails.rewards && params?.payment=='rd'" [currency]="contributeDetails?.selected_currency"
                [rewards]="contributeDetails?.rewards" [campaignId]="params?.id">
    </app-rewards>

    <div *ngIf="vars.selected_insurance?.vendor && !urlParams?.plan?.match('plus') && !vars.couponDetails" class="partner-pay">
      <app-component-loader selector="app-partner-plan-upgrade-nudge" />
    </div>

    <div *ngIf="isSipStory && params?.payment!=='options'" class="sip-details">
      <app-component-loader selector="app-sip-story-banner"
                        [inputs]="{ config: { theme: 'v02' } }"
      />
    </div>

    <app-amount-form [isReward]="checkReward()" [contributeDetails]="contributeDetails" [origin]="origin"
                    [campaignId]="params?.id" [hidden]="!(params?.payment=='form')" [config]="config"
                    (userSelectionCurrency)="getCurrencyFromHeader($event)" [isQR]="isQR"
                    [isLoading]="isCurrencyLoading" [paymentFlowType]="type" [isRewardSelected]="isRewardSelected" [inputFields]="inputFields"
                    [fixedAmount]="fixedAmount" [eventCause]="eventCause" [event]="event" [upiMode]="upiMode" (submitOrder)="optionsNav?.submitOrder($event)"
                    [onpage]="onpage" [captchaType]="captchaType" [skipFailedCase]="skipFailedCase" [recommendTag]="recommendTag" [paymentIcons]="paymentIcons"
                    [miniStory]="payment_config.mini_story" [position]="position" [isSipStory]="isSipStory" [tagLabel]="tagLabel" [theme]="theme" [payment_config]="payment_config">
    </app-amount-form>
    <app-options-nav [campaignId]="params?.id" [hidden]="!(params?.payment=='options')" [isQR]="isQR"
                    [origin]="params?.or || origin" [customTag]="params?.ct" [contributeDetails]="contributeDetails"
                    [eventCause]="eventCause" [peopleServed]="peopleServed" [updateId]="updateId" [skipFailedCase]="skipFailedCase"
                    [isSipStory]="isSipStory">
    </app-options-nav>
    <!-- <app-payment-option-v2 *ngIf="vwo.paymentV2AB()" [hidden]="!(params?.payment=='options')" [inputs]="{
        currency: paymentCur, user: userdata, paymentDetails: contributeDetails, fundraiser: fundraiser, origin: origin,
        paymentBtnClass: 'payment-btn-theme-v2', showUpiIntent: false, showTutorial: false, isQR: isQR, upiMode: upiMode
      }">
    </app-payment-option-v2> -->

  </section>
</ng-template>
<!-- Story payment module -->
<ng-template #storyPaymentRef>
  <section *ngIf="contributeDetails" id="full-payment-wrapper">
    <app-payment-header-stories *ngIf="config?.story_link && urlParams?.ct && isStoryLink && fundraiser?.story_title" [isReward]="checkReward()" [selectedCurrency]="contributeDetails?.selected_currency"
                        (userSelectionCurrency)="getCurrencyFromHeader($event)" [screenName]="screenName"
                        [fundraiser]="fundraiser" [showBeneficiary]="showBeneficiary" [contributeDetails]="contributeDetails">
    </app-payment-header-stories>
    <app-payment-header *ngIf="config?.story_link && !urlParams?.ct" [isReward]="checkReward()" [selectedCurrency]="contributeDetails?.selected_currency"
      (userSelectionCurrency)="getCurrencyFromHeader($event)" [screenName]="screenName"
      [fundraiser]="fundraiser" [showBeneficiary]="showBeneficiary" [contributeDetails]="contributeDetails">
    </app-payment-header>
    <app-options-nav [campaignId]="params?.id" [hidden]="!(params?.payment=='options')" [isQR]="isQR"
                    [origin]="params?.or || origin" [customTag]="params?.ct" [contributeDetails]="contributeDetails"
                    [isSipStory]="isSipStory">
    </app-options-nav>
    <!-- <app-payment-option-v2 *ngIf="vwo.paymentV2AB()" [hidden]="!(params?.payment=='options')" [inputs]="{
        currency: paymentCur, user: userdata, paymentDetails: contributeDetails, fundraiser: fundraiser, origin: origin,
        paymentBtnClass: 'payment-btn-theme-v2', showUpiIntent: false, showTutorial: false, isQR: isQR, upiMode: upiMode
      }">
    </app-payment-option-v2> -->
  </section>
</ng-template>

</div>
